import React from 'react';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from '@voltmoney/schema';
const FooterText = ({ label, screen = false }) => {
    return (React.createElement(Typography, { label: label, fontSize: FontSizeTokens.XS, fontWeight: screen ? '500' : '400', fontFamily: FontFamilyTokens.Inter, color: screen ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal, lineHeight: 16, textAlign: TextAlignTokens.center }));
};
export default FooterText;
